/**
 * Quy tắc dùng chung cho thẻ phân loại khách (customer_tag) — trang chi tiết
 * khách hàng và danh sách khách hàng phải xử lý giống nhau.
 */

// Chuẩn hóa tên thẻ: bỏ dấu tiếng Việt, bỏ dấu câu, gộp khoảng trắng -> so khớp bền với sai lệch nhỏ
export const normalizeTagName = (raw: any) =>
    String(raw || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-zA-Z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();

/**
 * Thẻ ngoài danh sách (khác group) mặc định chỉ hiển thị tĩnh.
 * Riêng các thẻ dưới đây được ưu tiên cho phép đổi sang thẻ khác:
 *  - "Mới - Tiếp cận"
 *  - "KNC - Sai thông tin, liên hệ lần đầu báo không nhu cầu luôn"
 */
export const isEditableFallbackTagName = (raw: any) => {
    const name = normalizeTagName(raw);
    if (!name) return false;
    if (name === "moi tiep can") return true;
    if (name.startsWith("knc") && name.includes("sai thong tin")) return true;
    return false;
};
